import uisApi from '@/api/uis';

const state = {
    isLoading: false,
    validationErrors: null,
    isSubmitting: false,
    settings:null,
    callOut:null,
    units:null
}

export const mutationTypes = {
    getSettings1cStart: '[uis] Get settings 1c start',
    getSettings1cSuccess: '[uis] Get settings 1c success',
    getSettings1cFailure: '[uis] Get settings 1c failure',

    getSettingsStart: '[uis] Get settings start',
    getSettingsSuccess: '[uis] Get settings success',
    getSettingsFailure: '[uis] Get settings failure',

    callOutStart: '[uis] Call out start',
    callOutSuccess: '[uis] Call out success',
    callOutFailure: '[uis] Call out failure',

    getUnitsStart: '[uis] Get units start',
    getUnitsSuccess: '[uis] Get units success',
    getUnitsFailure: '[uis] Get units failure',
}

export const uisActionTypes = {
    getSettings1c: '[uis] Get settings 1c',
    getSettings: '[uis] Get settings',
    callOut: '[uis] Call out',
    getUnits: '[uis] Get units'
}

const mutations = {
    [mutationTypes.getSettings1cStart](state) {
        state.isLoading = true
        state.listVisitor = null
    },
    [mutationTypes.getSettings1cSuccess](state, payload) {
        state.isLoading = false
        state.settings = payload
        state.validationErrors = null
    },
    [mutationTypes.getSettings1cFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getSettingsStart](state) {
        state.isLoading = true
        state.listVisitor = null
    },
    [mutationTypes.getSettingsSuccess](state, payload) {
        state.isLoading = false
        state.settings = payload
        state.validationErrors = null
    },
    [mutationTypes.getSettingsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.callOutStart](state) {
        state.isLoading = true
        state.listVisitor = null
    },
    [mutationTypes.callOutSuccess](state, payload) {
        state.isLoading = false
        state.callOut = payload
        state.validationErrors = null
    },
    [mutationTypes.callOutFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getUnitsStart](state) {
        state.isLoading = true
        state.listVisitor = null
    },
    [mutationTypes.getUnitsSuccess](state, payload) {
        state.isLoading = false
        state.units = payload
        state.validationErrors = null
    },
    [mutationTypes.getUnitsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },
}

const actions = {
    [uisActionTypes.getSettings1c](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getSettings1cStart)
            uisApi
                .getSettings1c(data)
                .then(response => {
                    context.commit(mutationTypes.getSettings1cSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getSettings1cFailure,response)
                })
        })
    },
    [uisActionTypes.getSettings](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getSettingsStart)
            uisApi
                .getSettings(data)
                .then(response => {
                    context.commit(mutationTypes.getSettingsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getSettingsFailure,response)
                })
        })
    },
    [uisActionTypes.callOut](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.callOutStart)
            uisApi
                .callOut(data)
                .then(response => {
                    context.commit(mutationTypes.callOutSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.callOutFailure,response)
                })
        })
    },
    [uisActionTypes.getUnits](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getUnitsStart)
            uisApi
                .getUnits(data)
                .then(response => {
                    context.commit(mutationTypes.getUnitsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getUnitsFailure,response)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations
}